import React from "react";
import styles from "./DriverConsent.module.scss";

const PeriodConsent = (props) => {
    const { setPeriodOfConsent, setChoicesData, untilDate, monthPeriod, employmentDuration } = props;

    const onChoiceChange = (e) => {
        setChoicesData(e.target.checked);
    };
    const onTextChange = (e) => {
        setPeriodOfConsent({ name: e.target.name, value: e.target.value });
    }

  return (
    <div className={`section ${styles.sectionGrey}`} style={{ backgroundColor: '#f0f0f0', padding: '20px 10px' }}>
    <div className="row">
      <div className="col-md-2">
        <h3 style={{ margin: 0 }}>Period of <br/>consent</h3>
        <p className="small">
        Complete one of these<br/>
        three consent options.
        </p>
      </div>
      <div className="col-md-10">
            <div>I give consent:</div>
            <div className={styles.darkGrey}>
                <div className="row">
                    <div className="col-md-10">
                        <div className="d-flex align-items-center">
                            <label htmlFor="monthPeriod" className="mr-2">a&#41; for a period of </label>
                            <input
                                type="text"
                                id="monthPeriod"
                                name="monthPeriod"
                                className={`form-control mr-2 ${styles.smallInput}`}
                                value={monthPeriod}
                                onChange={onTextChange}
                            />
                            <span> (eg 12 months)</span>
                        </div>
                    </div>
                </div>
                </div>
                <div><h3>OR</h3></div>
                <div className={styles.darkGrey}>
                    <div className="row">
                        <div className="col-md-10">
                            <div className="d-flex align-items-center">
                                <label htmlFor="untilDate" className="mr-2"> b&#41; until this date </label>
                                <input
                                    type="text"
                                    id="untilDate"
                                    name="untilDate"
                                    className={`form-control mr-2 ${styles.smallInput}`}
                                    value={untilDate}
                                    onChange={onTextChange}
                                />
                                <span> (eg 31 January 2022)</span>
                            </div>
                        </div>
                        </div>
                </div>
                <div><h3>OR</h3></div>
                <div className={styles.darkGrey}>
                    <div className="row">
                        <div className="col-md-10">
                        <div className="d-flex align-items-center">
                            <label htmlFor="employmentDuration" className="mr-2"> c&#41; </label>
                            <input
                                type="checkbox"
                                id="employmentDuration"
                                name="employmentDuration"
                                className={`form-control mr-2 ${styles.smallCheckbox}`}
                                checked={employmentDuration}
                                onChange={onChoiceChange}
                            />
                            <span>for the duration of my employment or contract with this company.</span>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default PeriodConsent;